module.exports = __webpack_public_path__ + "static/media/ic_app_icon_red.12ca9dfa.png";